module.exports = __webpack_public_path__ + "static/media/whtsap.329504d0.png";